export default function ExpertiseSection() {
  const expertise = [
    {
      icon: 'ri-settings-3-line',
      title: 'Metodologia Própria',
      description: 'Combinação de análise jurídica, estratégia competitiva e execução prática.'
    },
    {
      icon: 'ri-file-check-line',
      title: 'Sem Burocracia',
      description: 'Você só assina e emite a nota. Nós cuidamos de toda a parte técnica e operacional.'
    },
    {
      icon: 'ri-award-line',
      title: 'Exclusividade por Segmento',
      description: 'Foco total na sua empresa, sem conflito de interesses com concorrentes.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Visão 360º',
      description: 'Unimos a experiência prática dos processos da Administração Pública aos desafios reais das empresas.'
    }
  ];

  return (
    <section id="expertise" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Nossos Diferenciais
          </h2>
          <p className="text-lg text-text-grey max-w-3xl mx-auto">
            O que torna a LicitMax única no mercado de licitações e contratos públicos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {expertise.map((item, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-lg hover:shadow-xl transition-all duration-300 group cursor-pointer text-center"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-primary rounded-full mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-primary mb-4">
                {item.title}
              </h3>
              <p className="text-text-grey leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
